module.exports = __webpack_public_path__ + "media/images/emblems/Meikirch-coat_of_arms-7d4e85881c3b105056b58eb95217d2d0.svg";